import type { FC } from "react";
import { useSelector } from "react-redux";
import { usePollVotes } from "../../../../../../hooks/use-poll-votes";
import { selectBroadcastId } from "../../../../../../redux/broadcast/broadcast.selectors";
import type { Poll as PollType } from "../../../../../../types/polls.types";
import * as CSS from "../poll/poll.styles";
import PollOption from "../poll-option/poll-option";

type EndedPollProps = {
	poll: PollType;
	hideSeperator?: boolean;
};

const EndedPoll: FC<EndedPollProps> = ({ poll, hideSeperator = false }) => {
	const broadcastId = useSelector(selectBroadcastId);
	const { totalVotes, countsByOption } = usePollVotes(broadcastId, poll.id);

	return (
		<CSS.Poll $hideSeperator={hideSeperator}>
			<CSS.PollQuestion>{poll.question}</CSS.PollQuestion>
			{poll.options.map((option) => (
				<PollOption
					key={option}
					option={option}
					votes={countsByOption[option] ?? 0}
					totalVotes={totalVotes}
				/>
			))}
		</CSS.Poll>
	);
};

export default EndedPoll;
